import type React from "react";
import { Link, useLocation } from "react-router-dom";
import "./TopBar.css";
import { Home, Video, Music } from "./Icons"; // Custom icons

const TopBar: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path ? "active" : "";
  };

  return (
    <header className="topbar-container">
      <nav>
        <ul>
          <li className={isActive("/")}>
            <Link to="/" aria-label="Inicio">
              <Home />
              <span>INICIO</span>
            </Link>
          </li>
          <li className={isActive("/videos")}>
            <Link to="/videos" aria-label="Videos">
              <Video />
              <span>VIDEOS</span>
            </Link>
          </li>
          <li className={isActive("/audios")}>
            <Link to="/audios" aria-label="Audios">
              <Music />
              <span>AUDIOS</span>
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default TopBar;
